import React from "react";

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const MainButton = ({
  blok,
  links = [],
  variant = "primary",
  text,
  type,
  hideSbMetadata = false,
  onClick = () => {},
  ...restProps
}) => {

  const buttonClasses = cn("main-button", {
    "primary": variant === "primary",
    "secondary": variant === "secondary",
    "outline-primary": variant === "outline-primary",
    "outline-secondary": variant === "outline-secondary",
    "outline-secondary-negative": variant === "outline-secondary-negative",
  });

  return (
    <button className={buttonClasses} onClick={onClick} type={type}>
      <div className={cn("background")}></div>
      <div className={cn("label")}>
        <span className={cn("label-visible")}>{text}</span>
        <span className={cn("label-invisible")}>{text}</span>
      </div>
    </button>
  );
};

export default MainButton;
